import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { roles, routes } from '../../../../constants';
import { DownloadTemplateButton } from '../../../common/download-template/DownloadTemplateButton';
import { Breadcrumbs } from '../../../controls/breadcrumbs/Breadcrumbs';
import { BreadcrumbsItem } from '../../../controls/breadcrumbs/BreadcrumbsItem';
import { IssuanceMonitorTab } from '../../types/PipelineTabTypes';
import { amrArrangerPipelineActions } from '../../../../actions/amr-arranger-pipeline.actions';
import { gridActions } from '../../../../actions';
import { Grid } from '../../../grid';
import { DeleteAllButton } from '../../../grid/DeleteAllButton';
import { DeleteRowsWithErrorButton } from '../../../grid/DeleteRowsWithErrorButton';
import { GridUploadStatus } from '../../../../types/state/GridState';
import { ShowFor } from '../../../access';
import { user } from '../../../../user';
import { Preloader } from '../../../common';
import { useHistory } from 'react-router';
import { ArrangerPipelineSaveButton } from './ArrangersPipelineSaveButton';
import { useAppSelector } from '../../../../effects/useAppSelector';

export const ArrangerPipelineEdit = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const isGridUploading = useAppSelector(s =>
        s.grid.upload.status === GridUploadStatus.Uploading ||
        s.grid.upload.status === GridUploadStatus.UploadingSingle
    );
    const isSubmitted = useAppSelector(s => s.issuanceMonitor.amrArrangerPipeline.deals.isSubmitted);
    const isLoading = useAppSelector(s => s.issuanceMonitor.amrArrangerPipeline.deals.isLoading);

    const isBD = user.hasRoles(...roles.bd());

    useEffect(() => {
        dispatch(amrArrangerPipelineActions.edit());

        return () => {
            dispatch(gridActions.reset());
        };
    }, [dispatch]);

    useEffect(() => {
        if (isSubmitted) {
            dispatch(amrArrangerPipelineActions.reset());
            history.push(routes.imUrl(IssuanceMonitorTab.ArrangerPipeline));
            dispatch(amrArrangerPipelineActions.submitArrangerPipelineStatus(false));
        }
    }, [dispatch, history, isSubmitted]);

    const handleCancel = () => {
        dispatch(amrArrangerPipelineActions.reset());
        history.push(routes.imUrl(IssuanceMonitorTab.ArrangerPipeline))
    }

    return (
        <div className="arranger-pipeline-edit container">
            <Preloader inProgress={isLoading}>
                <div className="sub-header">
                    <div className="sub-header-row type01 flex-row position-relative">
                        <Breadcrumbs>
                            <BreadcrumbsItem>
                                <span onClick={handleCancel} className="btn-link secondary regular">
                                    Arranger's Pipeline
                                </span>
                            </BreadcrumbsItem>
                        </Breadcrumbs>
                        <h1>Edit List</h1>

                        <div className="flex-item-right controls">
                            <DeleteRowsWithErrorButton />
                            <DeleteAllButton disabled={isGridUploading} />
                            <ShowFor roles={[roles.Administrator, roles.DataEntry]}>
                                <DownloadTemplateButton templateType="SecuritiesXlsxTemplate" disabled={isGridUploading} />
                            </ShowFor>
                            <button
                                type="button"
                                className="btn btn-ghost"
                                onClick={handleCancel}
                                disabled={isGridUploading}
                            >
                                Cancel
                            </button>
                            <ArrangerPipelineSaveButton
                                disabled={isGridUploading}
                                handleSave={() => dispatch(amrArrangerPipelineActions.submitArrangerPipeline())}
                            />
                        </div>
                    </div>
                </div>
                <Grid dataUploadDisabled={isBD} helpPopoverTitle="You can add your securities in the following ways" />
            </Preloader>
        </div>
    );
};
